export const combineCategoryFilters = (query: any) => {
  const data: any = {};
  if (query.priceMin) {
    data["priceMin"] = query.priceMin;
  }
  if (query.priceMax) {
    data["priceMax"] = query.priceMax;
  }
  if (query.metal) {
    data["metal"] = query.metal;
  }
  if (query.size) {
    data["size"] = query.size;
  }
  if (query.occasion) {
    data["occasion"] = query.occasion;
  }
  if (query.fastDelivery) {
    data["fastDelivery"] = query.fastDelivery;
  }
  if (query.try_it_online) {
    data["try_it_online"] = query.try_it_online;
  }
  if (query.sort) {
    data["sort"] = query.sort;
  }
  return data;
};
